export { FastshiftDashboardPageTemplate } from "./fastshift-dashboard-page.template";
export { FastshiftDashboardPageTemplate as default } from "./fastshift-dashboard-page.template";
